// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Wy5x","largestCol":"styles_largestCol__1bau5","smallestCol":"styles_smallestCol__1vmVF"};